// This file defines the spacing scale used throughout the application.
// We use 'em' units to ensure that spacing scales appropriately with font size changes,
// considering a base font size of 16px.
/* eslint-disable sort-keys-fix/sort-keys-fix */
export const spaceRelativeMultiplier = {
    0: 0, // 0px
    1: 0.25, // 4px
    2: 0.5, // 8px
    3: 0.75, // 12px
    4: 1, // 16px
    5: 1.25, // 20px
    6: 1.5, // 24px
    7: 1.75, // 28px
    8: 2, // 32px
    9: 2.25, // 36px
    10: 2.5, // 40px
    12: 3, // 48px
    13: 3.25, // 52px
    14: 3.5, // 56px
    16: 4, // 64px
    18: 4.5, // 72px
    20: 5, // 80px
    22: 5.5, // 88px
    24: 6, // 96px
    28: 7, // 112px
    32: 8, // 128px
    36: 9, // 144px
    40: 10, // 160px
    44: 11, // 176px
    48: 12, // 192px
    52: 13, // 208px
    56: 14, // 224px
    60: 15, // 240px
    64: 16, // 256px
    72: 18, // 288px
    80: 20, // 320px
    96: 24, // 384px
    98: 25, // 400px
};
/* eslint-disable sort-keys-fix/sort-keys-fix */
export const space = Object.assign({ hairline: '1px', px: '1px' }, Object.entries(spaceRelativeMultiplier).reduce((acc, [key, value]) => {
    acc[key] = `${value}em`;
    return acc;
}, {}));
export default space;
